import type { Integration } from '@core/types/api/Integration/Integration';

import { useSlabQuery } from './useSlabQuery';

type IntegrationListResponse = {
  items: Integration[];
  count: number;
};

export const useIntegrations = (): {
  integrations: Integration[];
} & ReturnType<typeof useSlabQuery<'GET integrations'>> => {
  const query = useSlabQuery('GET integrations', {}, { retry: 1 });

  const response = query.data as unknown as IntegrationListResponse | null;

  const integrations = response?.items ?? [];

  return {
    ...query,
    integrations,
  };
};
